/**
 * PostHog endpoint ids used by PLH (must match soon-plh PLH_POSTHOG_ENDPOINT_ALLOWLIST).
 * Sorted for stable Settings UI order.
 */
export const PLH_POSTHOG_ENDPOINT_IDS: readonly string[] = [
  "ep_activated_to_paid",
  "ep_activated_to_paid_monthly",
  "ep_activation_funnel_data",
  "ep_activation_funnel_data_monthly",
  "ep_activation_parameters",
  "ep_new_signups_data",
  "ep_new_signups_data_monthly",
  "ep_scheduled_hours_monthly",
  "ep_time_to_activation",
  "ep_time_to_activation_monthly",
] as const;
